import { render, staticRenderFns } from "./DxLogs.vue?vue&type=template&id=368e76ee&"
import script from "./DxLogs.vue?vue&type=script&lang=js&"
export * from "./DxLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports